import CompatsMessageFeedabak from './compats-message-feedback';

export default CompatsMessageFeedabak;
